import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntidadSegundaInstanciaDto } from '../dto/expediente/entidad-segunda-instancia.dto';
import { CambioExpedienteSegundaInstanciaDto } from '../dto/expediente/cambio-expediente-segunda-instancia.dto';
import { Observable } from 'rxjs';
import { GenericResponseDto } from '../dto/util/generic-response.dto';
import { ExpedienteSegundaInstanciaDto } from '../dto/expediente/expediente-segunda-instancia.dto';
import { ExpedienteSegundaInstanciaFiltroDto } from '../dto/expediente/expediente-segunda-instancia.filtro.dto';
import { FiltroDto } from '../dto/util/filtro-dto';
import { PaginaDto } from '../dto/util/pagina-dto';
import { EstadoExpedientesSegundaInstanciaDto } from '../dto/expediente/estado-expedientes-segunda-instancia.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SegundaInstanciaService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/segunda-instancia';

  constructor(private httpClient: HttpClient) { }

  getEntidadesSegundaInstancia(): Observable<EntidadSegundaInstanciaDto[]>{
    return this.httpClient.get<EntidadSegundaInstanciaDto[]>(
      `${this.apiUrl}${this.baseUrl}`
    )
  }

  almacenarEntidadSegundaInstancia(nombreEntidad: string, activo: boolean): Observable<EntidadSegundaInstanciaDto>{
    return this.httpClient.post<EntidadSegundaInstanciaDto>(
      `${this.apiUrl}${this.baseUrl}/entidad`,
      {
        nombreEntidad,
        activo
      }
    )
  }

  cambioExpedienteASegundaInstancia(
    cambioExpedienteSegundaInstancia: CambioExpedienteSegundaInstanciaDto[]): Observable<GenericResponseDto>{
    return this.httpClient.post<GenericResponseDto>(
      `${this.apiUrl}${this.baseUrl}/actualizacion`, cambioExpedienteSegundaInstancia
      
    )
  }

  expedientesSegundaInstancia(
    filtros: FiltroDto<ExpedienteSegundaInstanciaFiltroDto>
  ): Observable<PaginaDto<ExpedienteSegundaInstanciaDto>>{
    return this.httpClient.post<PaginaDto<ExpedienteSegundaInstanciaDto>>(
      `${this.apiUrl}${this.baseUrl}/expedientes`, filtros
    )
  }

  estadoExpedientesSegundaInstancia(
    request?: ExpedienteSegundaInstanciaFiltroDto
  ): Observable<EstadoExpedientesSegundaInstanciaDto>{
    return this.httpClient.post<EstadoExpedientesSegundaInstanciaDto>(
      `${this.apiUrl}${this.baseUrl}/expedientes/estados`, request
    )
  }
}
